export default "__VITE_ASSET__fa413bbe__"